export default "__VITE_ASSET__tASAkGmb__"